import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgInformation = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19ZM11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11C21 16.5228 16.5228 21 11 21ZM12 16H10V10H12V16ZM11 8.5C10.1716 8.5 9.5 7.82843 9.5 7C9.5 6.17157 10.1716 5.5 11 5.5C11.8284 5.5 12.5 6.17157 12.5 7C12.5 7.82843 11.8284 8.5 11 8.5Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgInformation);

export default ForwardRef;
